export class TokenContent {
  aud: string; // Audience
  exp: number; // expires time (unix epoch)
  given_name: string; // users full name
  iat: number; // time signed (unix epoch)
  iss: string; // Issuer
  jti: string; // Guid
  nameid: string; // User ID
  nbf: number;
  permission: string | string[]; // permissions the user has, may be just one string or an array
  role: string | string[]; // user roles, may be just one string or an array
  sub: string; // subject (user ID)
  unique_name: string; // User name
  name: string; // User name >= .NET 6
  remember_me: boolean; // Remeber me status
  Rata_SystemUserId: string
  Rata_AccountName: string; // name of the user account
  Rata_AccountId: string; // id of the user account
  Rata_LaboratoryName: string; //name of the user laboratory
  Rata_LaboratoryId: string; //id of the user laboratory
  Rata_DistributorName: string; //name of the user distributor
  Rata_DistributorId: string; //id of the user distributor
  Rata_LaboratoryGroupName: string; //name of the user laboratory group
  Rata_LaboratoryGroupId: string; //id of the user laboratory group
  AllPermissions: string;
  RataTracProcessingSite: string;
  IsGlobalSupport: string;
  Rata_StaffId: string;
  Renee_StaffId: string;
  Renee_MarkupStaff: string;
}
